<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>权限设置</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-table :data="authList" border stripe :row-style="{height: '0'}" :header-cell-style="{background:'#003c76', color:'#fff'}">
        <el-table-column type="index"></el-table-column>
        <el-table-column label="权限名称" prop="authorName"></el-table-column>
        <el-table-column label="路径" prop="authorKey"></el-table-column>
        <el-table-column label="等级" prop="level">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.level === 1">一级</el-tag>
            <el-tag v-if="scope.row.level === 2" type="success">二级</el-tag>
            <el-tag v-if="scope.row.level === 3" type="warning">三级</el-tag>
          </template>

        </el-table-column>
      </el-table>
    </el-card>
  </div>

</template>

<script>
export default {
  name: "Auths",
  data(){
    return{
      authList: []
    }
  },
  created() {
    this.getAuthList();
  },
  methods: {
    async getAuthList(){
      const {data:res} = await this.$http.get("/auths");
      if (res.code !== 200){
         return this.$message.error("获取权限列表失败！")
      }
      this.authList = res.data;
    }
  }
}
</script>

<style lang="less" scoped>
.el-table{
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Auths.vue